import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  root: {
    display: 'inline-flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    lineHeight: 0,
  },
  iconWrapper: {
    display: 'inline-flex',
    lineHeight: 0,
  },
  smallPadding: {
    paddingRight: theme.spacing(1),
  },
  mediumPadding: {
    paddingRight: theme.spacing(1.5),
  },
  largePadding: {
    paddingRight: theme.spacing(3),
  },
}));
